import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { HEADER_HUB_RING_WHEEL_OPTIONS, HEADER_LOCK_NUT_WHEEL_OPTIONS, HEADER_NUT_WHEEL_OPTIONS } from "constants/data";
import TireOptionTable from "../components/TireOptionTable";
import WheelOptionTable from "../components/WheelOptionTable";
import useOptionList from "../hooks/useOptionList";

/**
 * The ItemList Page.
 */
function OptionList() {
  const navigate = useNavigate();
  const {
    natOptions,
    hubOptions,
    lockNatOptions,
    protectionOptions,
    setNatOptions,
    setHubOptions,
    setLockNatOptions,
    setProtectionOptions,
    updateOption,
    updatePructureProtection,
  } = useOptionList();
  return (
    <>
      <Box sx={{ px: { xs: 2, md: 2.5, lg: 5 }, pt: { xs: 2, md: 2.5, lg: 3 } }}>
        <Button onClick={() => navigate(-1)} variant="custom-outlined">
          <Box>＜ 戻る</Box>
        </Button>
      </Box>
      <Box
        sx={{
          p: { xs: 2, md: 2.5, lg: 5 },
          display: { xs: "block", lg: "flex" },
          columnGap: { xs: 0, lg: 10, xl: 20 },
        }}
      >
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography
          variant="h4"
          margin={0}
          textAlign="left"
          sx={{ fontSize: { xs: 28, lg: 33 }, color: "var(--gray-600)" }}
        >
          マスタ管理
        </Typography>
        <Typography
          variant="h5"
          margin={0}
          textAlign="left"
          sx={{ fontSize: { xs: 24, lg: 28 }, color: "var(--gray-600)", whiteSpace: "nowrap" }}
        >
          商品オプション
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          // marginX: "auto",
          gap: 4,
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontSize: { xs: 24, lg: 33 }, mb: { xs: 0, lg: 4 }, color: "var(--gray-600)" }}
        >
          タイヤオプション
        </Typography>
        <Box
          sx={{
            mx: "auto",
            width: "100%",
            maxWidth: { xs: "100%", md: 870 },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%" },
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 16, lg: 20 },
                fontWeight: "medium",
                color: "var(--black)",
              }}
            >
              パンク補償
            </Typography>
            <Box sx={{ overflowX: "auto", width: "100%" }}>
              <TireOptionTable
                data={protectionOptions}
                setData={setProtectionOptions}
                onUpdateItem={updatePructureProtection}
              />
            </Box>
          </Box>
        </Box>
        <Typography
          sx={{
            mb: { xs: 1, lg: 1 },
            fontSize: { xs: 24, lg: 32 },
            fontWeight: "medium",
            color: "var(--gray-600)",
          }}
        >
          ホイールオプション
        </Typography>
        <Box
          sx={{
            mx: "auto",
            width: "100%",
            maxWidth: { xs: "100%", md: 870 },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%" },
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 16, lg: 20 },
                fontWeight: "medium",
                color: "var(--black)",
                mt: 2,
              }}
            >
              ナット{" "}
              <span style={{ fontWeight: "normal", color: "var(--gray-600)" }}>
                ※JANコードなしでの登録可能
              </span>
            </Typography>
            <Box sx={{ overflowX: "auto", width: "100%" }}>
              <WheelOptionTable
                labelHeader={HEADER_NUT_WHEEL_OPTIONS}
                data={natOptions}
                setData={setNatOptions}
                onUpdateItem={updateOption}
              />
            </Box>

            <Typography
              sx={{
                fontSize: { xs: 16, lg: 20 },
                fontWeight: "medium",
                color: "var(--black)",
                mt: 2,
              }}
            >
              ロックナット
            </Typography>
            <Box sx={{ overflowX: "auto", width: "100%" }}>
              <WheelOptionTable
                labelHeader={HEADER_LOCK_NUT_WHEEL_OPTIONS}
                data={lockNatOptions}
                setData={setLockNatOptions}
                onUpdateItem={updateOption}
              />
            </Box>

            <Typography
              sx={{
                fontSize: { xs: 16, lg: 20 },
                fontWeight: "medium",
                color: "var(black)",
                mt: 2,
              }}
            >
              ハブリング
            </Typography>
            <Box sx={{ overflowX: "auto", width: "100%" }}>
              <WheelOptionTable
                labelHeader={HEADER_HUB_RING_WHEEL_OPTIONS}
                data={hubOptions}
                setData={setHubOptions}
                onUpdateItem={updateOption}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
    </>
  );
}

export default OptionList;
